import { Col, Row, Space } from 'antd';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { type DealerFragmentFragment } from '../../../../api/fragments/DealerFragment';
import { ApplicationMarket } from '../../../../api/types';
import DisclaimersDrawerField from '../../../../components/fields/DisclaimersDrawerField';
import CollapsibleWrapper, { Panel } from '../../../../components/wrappers/CollapsibleWrapper';
import useMarkDownInfoTooltip from '../../../../utilities/useMarkDownInfoTooltip';

const colSpan = { lg: 8, xs: 24 };

type DealerDisclaimersProps = {
    disabled?: boolean;
    dealer: DealerFragmentFragment;
};

const DealerDisclaimers = ({ disabled, dealer }: DealerDisclaimersProps) => {
    const { t } = useTranslation('dealerForm');
    const { company } = dealer;

    const marketType = useMemo(() => {
        switch (dealer.company?.countryCode) {
            case 'SG':
                return ApplicationMarket.Singapore;

            case 'NZ':
                return ApplicationMarket.NewZealand;

            default:
                return undefined;
        }
    }, [dealer.company?.countryCode]);

    const markdownInfoTooltip = useMarkDownInfoTooltip(marketType);
    const insuranceMarkdownInfoTooltip = useMarkDownInfoTooltip();

    return (
        <Space direction="vertical" style={{ width: '100%' }}>
            <CollapsibleWrapper defaultActiveKey={t('dealerForm:disclaimersTitle')}>
                <Panel key={t('dealerForm:disclaimersTitle')} header={t('dealerForm:disclaimersTitle')}>
                    <Row gutter={14}>
                        {company.availableModules.hasFinanceProducts && (
                            <Col {...colSpan}>
                                <DisclaimersDrawerField
                                    {...t('dealerForm:fields.dealerInput.disclaimers.financingDisclaimer', {
                                        returnObjects: true,
                                    })}
                                    disabled={disabled}
                                    disclaimerKind="financingDisclaimer"
                                    name="dealerInput.disclaimers.financingDisclaimer"
                                    tooltip={markdownInfoTooltip}
                                />
                            </Col>
                        )}
                        {company.availableModules.hasInsuranceModules && (
                            <Col {...colSpan}>
                                <DisclaimersDrawerField
                                    {...t('dealerForm:fields.dealerInput.disclaimers.insuranceDisclaimer', {
                                        returnObjects: true,
                                    })}
                                    disabled={disabled}
                                    disclaimerKind="insuranceDisclaimer"
                                    name="dealerInput.disclaimers.insuranceDisclaimer"
                                    tooltip={insuranceMarkdownInfoTooltip}
                                />
                            </Col>
                        )}
                    </Row>
                </Panel>
            </CollapsibleWrapper>
        </Space>
    );
};

export default DealerDisclaimers;
